import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Polyline, Marker, Popup, useMapEvents } from "react-leaflet";
import { fetchDataFromFirebaseGPS } from '../FireBase/firebaseService';
import { getDistance } from 'geolib';
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "../CSS/map.css";
import Swal from 'sweetalert2';

function CarMap() {
  const [path, setPath] = useState([]);
  const collectionName = localStorage.getItem('collectionName') || '/data';
  const [startPoint, setStartPoint] = useState(null);
  const [autoStartPoint, setAutoStartPoint] = useState(null);
  const [tempStartPoint, setTempStartPoint] = useState(null);
  const [laps, setLaps] = useState(0);
  const [wasAway, setWasAway] = useState(true);
  const [isLocked, setIsLocked] = useState(false);
  const [lastLapTime, setLastLapTime] = useState(null);
  const [lapTimer, setLapTimer] = useState(0);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [isReplaying, setIsReplaying] = useState(false);
  const [replayIndex, setReplayIndex] = useState(0);

  const lapDelay = 15000;
  
  useEffect(() => {
    const unsubscribe = fetchDataFromFirebaseGPS(collectionName, (gpsPoints) => {
      const validPoints = gpsPoints.map(({ latitude, longitude }) => ({
        lat: latitude,
        lng: longitude
      }));

      setPath(validPoints);

      if (validPoints.length > 0 && !autoStartPoint && !startPoint) {
        setAutoStartPoint(validPoints[0]);
      }
    });

    return () => unsubscribe();
  }, [collectionName, autoStartPoint, startPoint]);


  useEffect(() => {
    if (isLocked && startPoint && path.length > 0) {
      const currentPoint = path[path.length - 1];
      const distance = getDistance(
        { latitude: startPoint.lat, longitude: startPoint.lng },
        { latitude: currentPoint.lat, longitude: currentPoint.lng }
      );

      if (distance < 20) {
        if (wasAway) {
          const currentTime = Date.now();
          if (!lastLapTime || currentTime - lastLapTime >= lapDelay) {
            setLaps((prevLaps) => prevLaps + 1);
            setLastLapTime(currentTime);
            setWasAway(false);
            setIsTimerRunning(true);
          }
        }
      } else {
        setWasAway(true);
      }
    }
  }, [path, startPoint, wasAway, lastLapTime, isLocked]);

  useEffect(() => {
    let timer;
    if (isTimerRunning) {
      timer = setInterval(() => {
        setLapTimer((prevTime) => prevTime + 1);
      }, 1000);
    } else {
      setLapTimer(0);
    }

    return () => clearInterval(timer);
  }, [isTimerRunning]);

  function SetStartPoint() {
    useMapEvents({
      click(e) {
        if (!isLocked) {
          const { lat, lng } = e.latlng;
          setTempStartPoint({ lat, lng });
        }
      }
    });
    return null;
  }

  function replayPath() {
    setIsReplaying(true);
    setReplayIndex(0);
    setPath([]);
      let replayInterval = setInterval(() => {
        updateReplayIndex(replayInterval);
      }, 1000);
    }
  
    function updateReplayIndex(replayInterval) {
      setReplayIndex((prevIndex) => {
        if (prevIndex >= path.length - 1) {
          clearInterval(replayInterval);
          setIsReplaying(false);
          return prevIndex;
        }
        setPath((prevPath) => [...prevPath, path[prevIndex]]);
        console.log(path[replayIndex], replayIndex);
        if (startPoint) {
        console.log( getDistance(
          { latitude: startPoint.lat, longitude: startPoint.lng || 0 },
          { latitude: path[prevIndex ].lat, longitude: path[prevIndex ].lng }
        ))
        }
        return prevIndex + 1;
      });
  }

  function confirmStartPoint() {
    if (tempStartPoint) {
      setStartPoint(tempStartPoint);
      setIsLocked(true);
    }
  }

  async function resetStartPoint() {
    const confirmDelete = await Swal.fire({
      title: 'Confirmation',
      html: `Etes-vous sûr de vouloir réinitialiser le point de départ ?<br></br>Le nouveau point de départ sera le premier point capturé sur ce circuit.<br>Le chronomètre sera réinitialisé et ne pourra pas être récupéré.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui',
      cancelButtonText: 'Annuler',
      customClass: {
        confirmButton: 'swal2-delete-confirm',
        cancelButton: 'swal2-delete-cancel'
      }
    });
    if(!confirmDelete.isConfirmed) return;
    setStartPoint(null);
    setTempStartPoint(null);
    setAutoStartPoint(null);
    setLaps(0);
    setIsLocked(false);
    setLastLapTime(null);
    setLapTimer(0);
    setIsTimerRunning(false);
  }

  const carIcon = new L.Icon({
    iconUrl: "https://img.icons8.com/ios/452/car.png",
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, -16],
  });

  const startPointIcon = new L.Icon({
    iconUrl: "https://img.icons8.com/ios/452/flag.png",
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, -16],
  });

  const startTempPointIcon = new L.Icon({
    iconUrl: "https://img.icons8.com/color/ios/452/flag.png",
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, -16],
  });

  const currentPoint = path.length > 0 ? path[path.length - 1] : null;

  return (
    <div style={{ textAlign: "center", padding: "10px" }}>
      <h2>Suivi du véhicule</h2>
      <p><strong>Tours réalisés :</strong> {laps}</p>
      <p><strong>Temps du tour :</strong> {new Date(lapTimer * 1000).toISOString().slice(14, 19)}</p> 
      <button onClick={replayPath} disabled={isReplaying}>🔄 Rejouer</button>

      {!isLocked && tempStartPoint && (
        <div class="startPoint">
          <p>Point de départ sélectionné. Cliquez pour confirmer.</p>
          <div id="confirmButtons">
            <button onClick={confirmStartPoint} class="confirmButton">Verrouiller le point de départ</button>
            <button onClick={() => setTempStartPoint(null)} class="resetButton">Annuler</button>
          </div>
        </div>
      )}

      {isLocked && (
        <div class="startPoint">
          <button onClick={resetStartPoint} class="resetButton">🔓 Déverrouiller le point de départ</button>
        </div>
      )}

      {path.length > 0 ? (
        <MapContainer center={currentPoint || [0, 0]} zoom={18} style={{ height: "500px", width: "100%" }}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
          />
          {!isLocked && <SetStartPoint />}

          {autoStartPoint && !startPoint && (
            <Marker position={autoStartPoint} icon={startPointIcon}>
              <Popup>🔵 Point de départ automatique</Popup>
            </Marker>
          )}

          {tempStartPoint && !isLocked && (
            <Marker position={tempStartPoint} icon={startTempPointIcon}>
              <Popup>Prévisualisation du point de départ</Popup>
            </Marker>
          )}

          {startPoint && (
            <Marker position={startPoint} icon={startPointIcon}>
              <Popup>Point de départ</Popup>
            </Marker>
          )}

          <Polyline positions={path} color="blue" />
          {currentPoint && (
            <Marker position={currentPoint} icon={carIcon}>
              <Popup>
                <h4>Position actuelle de la voiture</h4>
              </Popup>
            </Marker>
          )}
        </MapContainer>
      ) : (
        <p>Chargement des données...</p>
      )}
    </div>
  );
}

export default CarMap;
